import showSuccessWindow from '../../../../common/components/successPopup/successPopup';
import { successSetTemplate } from '../../Order/components/OrderCard/popup/success';

const adjustDataTemplateForm = (data, type) => {
  let newData = {
    t2: data.t2 ? data.t2 : '',
    t4: data.t4 ? data.t4 : '',
    t6: data.t6 ? data.t6 : '',
    t7: data.t7 ? data.t7 : '',
    t8: data.t8 ? data.t8 : '',
    t9: data.t9 ? data.t9 : '',
    sh1: data.sh1 ? data.sh1 : '',
    sh2: data.sh2 ? data.sh2 : '',
    sh3: data.sh3 ? data.sh3 : '',
    kp1t: data.kp1t ? data.kp1t : '',
    kp2t: data.kp2t ? data.kp2t : '',
    kp3t: data.kp3t ? data.kp3t : '',
    kp4t: data.kp4t ? data.kp4t : '',
    kp1p: data.kp1p ? data.kp1p : '',
    kp2p: data.kp2p ? data.kp2p : '',
    kp3p: data.kp3p ? data.kp3p : '',
    kp4p: data.kp4p ? data.kp4p : '',
    kz1t: data.kz1t ? data.kz1t : '',
    kz2t: data.kz2t ? data.kz2t : '',
    kz3t: data.kz3t ? data.kz3t : '',
    kz4t: data.kz4t ? data.kz4t : '',
    kz1p: data.kz1p ? data.kz1p : '',
    kz2p: data.kz2p ? data.kz2p : '',
    kz3p: data.kz3p ? data.kz3p : '',
    kz4p: data.kz4p ? data.kz4p : '',
    s1: data.s1 ? data.s1 : '',
  };

  newData.vehicle = data.vehicle;
  newData.vehicleId = data.vehicleId;

  return newData;
};

const setTemplateToForm = (form, data, type) => {
  const newData = adjustDataTemplateForm(data, type);
  // избавляемся от тех полей которых нет в форме, чтобы не вылетали варнинги
  const formData = Object.keys(form.getFieldsValue()).reduce((acc, key) => {
    if (newData.hasOwnProperty(key)) {
      acc[key] = newData[key];
    }
    return acc;
  }, {});
  form.setFieldsValue(formData);
  showSuccessWindow(successSetTemplate(data.offerTemplateName));
};
export default setTemplateToForm;
